import { render, staticRenderFns } from "./TopTenUSCovidTests.vue?vue&type=template&id=2c7bf618&"
import script from "./TopTenUSCovidTests.vue?vue&type=script&lang=js&"
export * from "./TopTenUSCovidTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports